import { BannerLayout, BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';
import { LoadingIndicator } from 'ui-components/components/loading-indicator';
import { Text, TextType } from 'ui-components/components/text';

import { InventorySync } from './inventory-sync';
import { messages } from './messages';
import styles from './styles.module.less';
import { useOnComponentMount } from '../../../../../../../../../hooks/use-on-component-mount';
import { useInventorySyncContext } from '../../../../../context/inventory-sync-context';

export const InventoryTrackingSetup = () => {
  const { fetchConsolidatedInventoryConnections, sources, targets, loading } = useInventorySyncContext();

  // make sure the component has the latest connections when it mounts
  useOnComponentMount(() => {
    fetchConsolidatedInventoryConnections();
  });

  if (loading) {
    return <LoadingIndicator className={styles['loading-spinner']} />;
  }

  // inventory sync requires at least one source and one target
  if (!targets.length || !sources.length) {
    return null;
  }

  return (
    <section className={styles['inventory-setup']}>
      <Text className={styles['inventory-setup-title']} textType={TextType.H2} value={messages.inventoryTrackingTitle} />
      <Text className={styles['inventory-setup-description']} textType={TextType.Paragraph} value={messages.inventoryTrackingDescription} />
      <BannerMessageV2
        bannerContainerClassName={styles['info-banner-container']}
        className={styles['info-banner']}
        content={<Text textType={TextType.Paragraph} value={messages.syncInfo} />}
        layout={BannerLayout.Inline}
        status={BannerStatus.Info}
      />
      <InventorySync />
    </section>
  );
};
